var _style, _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _ellipse, _ellipse2, _ellipse3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _ellipse4, _ellipse5, _ellipse6, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _circle3, _path24, _path25, _path26, _path27, _path28, _path29, _use, _use2, _path30, _g4, _use3, _use4, _path31, _path32, _g5, _ellipse7, _ellipse8, _ellipse9, _path33, _g6, _path34, _path35, _path36, _path37, _path38, _path39, _circle4, _circle5, _circle6, _path40, _path41, _g7, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle7, _circle8, _circle9, _path49, _path50, _path51, _ellipse0, _path52, _g8, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle0, _circle1, _circle10, _path60, _path61, _path62, _g9, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _ellipse1, _ellipse10, _ellipse11, _path74, _path75, _path76, _path77, _path78, _g0, _path79;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920.11 160.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Bj{opacity:.4}.Bk{opacity:.55}.Bl{fill:#37117a}.Bm{stroke-linecap:round}.Bn{stroke-miterlimit:10}.Bo{fill:#2b0a66}.Bp{opacity:.25}.Bq{fill:#5419b8}.Br{fill:#441a8f}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "G",
    x1: 781.84,
    x2: 870.91,
    y1: 30.24,
    y2: 30.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edbbad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ed957d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42e4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "H",
    x1: 750.47,
    x2: 774.09,
    y1: 14.6,
    y2: 19.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b48aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c48dd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d28fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#de929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e6938b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#eb9480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ed957d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed627d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "I",
    x1: 750.49,
    x2: 774.11,
    y1: 14.54,
    y2: 19.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "J",
    x1: 750.49,
    x2: 774.11,
    y1: 14.53,
    y2: 19.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "K",
    x1: 810.065,
    x2: 842.272,
    y1: 88.939,
    y2: 90.616
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "L",
    x1: 944.17,
    x2: 710.66,
    y1: 65.43,
    y2: 86.81
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#230c45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#230c45",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#230c45",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230c45",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#230c45",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#230c45",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#230c45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "M",
    x1: 568.11,
    x2: 609.67,
    y1: 88.04,
    y2: 88.04,
    gradientTransform: "scale(-1 1)rotate(3.53 -241.223 -27297.886)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "N",
    x1: 513.19,
    x2: 609.56,
    y1: 28.2,
    y2: 28.2,
    gradientTransform: "matrix(-1 0 0 1 1670.23 0)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "O",
    x1: 1043.04,
    x2: 1054.43,
    y1: 42.64,
    y2: 40.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "P",
    x1: 1043.62,
    x2: 1055,
    y1: 42.68,
    y2: 40.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "Q",
    x1: 1043.98,
    x2: 1055.36,
    y1: 42.51,
    y2: 39.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "R",
    x1: 1179.1,
    x2: 934.68,
    y1: 84.04,
    y2: 70.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#230c45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#230c45",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#230c45",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#230c45",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#230c45",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#230c45",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#230c45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "T",
    x1: 358.19,
    x2: 405.27,
    y1: 26.03,
    y2: 29.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "U",
    x1: 358.2,
    x2: 405.29,
    y1: 25.83,
    y2: 29.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "V",
    x1: 358.21,
    x2: 405.29,
    y1: 25.72,
    y2: 28.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "W",
    x1: 570.71,
    x2: 629.81,
    y1: 90.91,
    y2: 90.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#230c45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#230c45",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#230c45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "X",
    x1: 438.29,
    x2: 437.46,
    y1: 100.78,
    y2: 207.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#491ba9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "Y",
    x1: 487.57,
    x2: 486.32,
    y1: 138.15,
    y2: 181.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#491ba9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#W",
    id: "d",
    x1: 595.96,
    x2: 646.43,
    y1: 141.09,
    y2: 99.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "e",
    x1: 607.16,
    x2: 641.3,
    y1: 13.67,
    y2: 21.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "f",
    x1: 607.46,
    x2: 641.76,
    y1: 12.65,
    y2: 20.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "g",
    x1: 606.49,
    x2: 642.1,
    y1: 11.36,
    y2: 19.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "h",
    x1: 700.84,
    x2: 795.71,
    y1: 62.93,
    y2: 62.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2fc5cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2fbec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27a9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "i",
    x1: 700.86,
    x2: 795.69,
    y1: 73.28,
    y2: 73.28
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5fc3c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5fb4b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e8a9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "j",
    x1: 700.89,
    x2: 795.66,
    y1: 83.63,
    y2: 83.63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ec0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8ea9a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#766c83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "k",
    x1: 700.91,
    x2: 795.64,
    y1: 93.99,
    y2: 93.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebeb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#be9f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d4d67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "l",
    x1: 700.94,
    x2: 795.61,
    y1: 104.34,
    y2: 104.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "m",
    x1: 700.04,
    x2: 741.22,
    y1: 44.44,
    y2: 44.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ed957d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbbad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "n",
    x1: 1405.367,
    x2: 1423.245,
    y1: 5.613,
    y2: 3.025
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "o",
    x1: 1405.46,
    x2: 1423.339,
    y1: 6.232,
    y2: 3.634
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "p",
    x1: 1405.558,
    x2: 1423.437,
    y1: 6.911,
    y2: 4.323
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#W",
    id: "q",
    x1: 1438.63,
    x2: 1402.52,
    y1: 81.09,
    y2: 78.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "r",
    x1: 1461.71,
    x2: 1584.57,
    y1: 6.64,
    y2: 112.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00c8d7",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#04c4d6",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#11b8d4",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#26a5d1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4589cd",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6b67c8",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#884ec5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "s",
    x1: 1516.45,
    x2: 1515.2,
    y1: 69.52,
    y2: 67.46
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fdf3f4",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f9d7d9",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f3a8ac",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "t",
    x1: 1481.39,
    x2: 1498.35,
    y1: 110.25,
    y2: 88.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b48aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c48dd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#d28fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#de929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6938b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eb9480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ed957d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ed627d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed375a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "u",
    x1: 1147.45,
    x2: 1163.58,
    y1: 15.85,
    y2: 12.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "v",
    x1: 1147.57,
    x2: 1163.7,
    y1: 16.4,
    y2: 12.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "w",
    x1: 1147.71,
    x2: 1163.84,
    y1: 17.02,
    y2: 13.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "x",
    x1: 1177.08,
    x2: 1376.9,
    y1: 59.02,
    y2: 59.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f54c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5353c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5f52c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7350c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#884ec5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "y",
    x1: 1145.68,
    x2: 1382.85,
    y1: 53.6,
    y2: 53.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#m",
    id: "AA",
    x1: 1241.13,
    x2: 1319.46,
    y1: 90.04,
    y2: 90.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AB",
    x1: 1281.8,
    x2: 1339.65,
    y1: 141.43,
    y2: 83.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ec6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1ec2cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19b5c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AC",
    x1: 1282.37,
    x2: 1338.86,
    y1: 149.05,
    y2: 92.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bc5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3bbbc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31a2b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AD",
    x1: 1282.94,
    x2: 1338.07,
    y1: 156.67,
    y2: 101.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59c3c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#59b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a8ea3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AE",
    x1: 1283.51,
    x2: 1337.29,
    y1: 164.29,
    y2: 110.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#77afaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627b91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AF",
    x1: 1280.27,
    x2: 1332.49,
    y1: 168.1,
    y2: 115.88
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94c0bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#94a89f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b6880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AG",
    x1: 1269.64,
    x2: 1320.43,
    y1: 164.52,
    y2: 113.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2beb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b2a293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93556e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AH",
    x1: 1260.26,
    x2: 1309.56,
    y1: 162.19,
    y2: 112.88
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfbdb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cf9b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac415d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "AI",
    x1: 1251.86,
    x2: 1299.54,
    y1: 160.84,
    y2: 113.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AJ",
    x1: 1164.867,
    x2: 1039.617,
    y1: 4.643,
    y2: 24.159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fefafa",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fcedee",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f9d7d9",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f5b9bd",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f09499",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AK",
    x1: 912.285,
    x2: 573.023,
    y1: 67.977,
    y2: 152.337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f7c9cc",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f0969b",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ec767c",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AJ",
    id: "AL",
    x1: 800.6,
    x2: 880.34,
    y1: 18.9,
    y2: 18.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AM",
    x1: 292.051,
    x2: 432.806,
    y1: 102.846,
    y2: 114.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d74ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c9df7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7fa2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#88b2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#97cdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#acf2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AN",
    x1: 1044.435,
    x2: 1319.284,
    y1: 102.894,
    y2: 150.324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fdf3f4",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f9d7d9",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f3a8ac",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AN",
    id: "AO",
    x1: 1047.691,
    x2: 1322.54,
    y1: 83.705,
    y2: 131.135
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AW",
    x1: 961.86,
    x2: 961.94,
    y1: 75.97,
    y2: 86.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c2b0de",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49169f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AW",
    id: "AX",
    x1: 916.85,
    x2: 916.85,
    y1: 86.65,
    y2: 129.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AW",
    id: "AY",
    x1: 1009.61,
    x2: 1009.61,
    y1: 86.65,
    y2: 129.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "AZ",
    x1: 813.8,
    x2: 839.01,
    y1: 116.56,
    y2: 116.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67feb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b181cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#bf84ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ca8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d28781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d78876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d98973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d95a73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AZ",
    id: "Aa",
    y1: 116.44,
    y2: 116.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AZ",
    id: "Ab",
    y1: 116.34,
    y2: 116.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "Ac",
    x1: 773.51,
    x2: 1149.27,
    y1: 125.59,
    y2: 125.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ccbbe9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5419b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#AZ",
    id: "Ad",
    x1: 736.4,
    x2: 883.27,
    y1: 140.44,
    y2: 140.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Ai",
    id: "Ae",
    x1: 710.56,
    x2: 852.75,
    y1: 140.44,
    y2: 140.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e5ddf4",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c3afe5",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a586d8",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8b64cd",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7748c4",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6732be",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5c23b9",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#551bb6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5419b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#t",
    id: "Af",
    x1: 1532.4,
    x2: 1668.37,
    y1: -33.55,
    y2: 109.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ai",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "A",
    cx: 981.82,
    cy: 59.71,
    r: 964.8,
    fx: 981.82,
    fy: 59.71,
    gradientTransform: "matrix(.99 0 0 .38 -.03 37.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#772ef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6f2be3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5d23bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3f1780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#230c45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#230c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#260d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2b0e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33106a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3c1380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#48169b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#561abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d1cca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "B",
    cx: 3077.28,
    cy: -2043.91,
    r: 123.19,
    fx: 3077.28,
    fy: -2043.91,
    gradientTransform: "rotate(13.53 -7108.182 -12673.152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5d77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f77ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f77fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f889bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f99ad8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb3ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "C",
    cx: 5902.51,
    cy: 2711.64,
    r: 179.87,
    fx: 5902.51,
    fy: 2711.64,
    gradientTransform: "rotate(-70.87 1146.332 5342.078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cc313b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#cc313b",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc313b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "D",
    cx: 3553.38,
    cy: -947.84,
    r: 117.48,
    fx: 3553.38,
    fy: -947.84,
    gradientTransform: "rotate(-24.71 4201.865 7097.299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f300ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f202fb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f11ed2",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f035b1",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ef4797",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ef5384",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ef5a7a",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ef5d77",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d4577e",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#93488f",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6b409a",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d3d9e",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "E",
    cx: 370.11,
    cy: -596.51,
    r: 129.24,
    fx: 370.11,
    fy: -596.51,
    gradientTransform: "matrix(-.63984 -.7685 .6148 -.51187 789.01 98.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ffb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#cbf09a",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#b7e589",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#aade7f",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a6dc7b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "F",
    cx: 961.79,
    cy: 50.42,
    r: 48.4,
    fx: 961.79,
    fy: 50.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ffb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d5f6a4",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c7ee97",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#bbe78d",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#b2e285",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#abdf7f",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a7dc7c",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a6dc7b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#E",
    id: "S",
    cx: 595,
    cy: 146.51,
    r: 224.62,
    fx: 595,
    fy: 146.51
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "Z",
    cx: 582.81,
    cy: 160.97,
    r: 74.36,
    fx: 582.81,
    fy: 160.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#975def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a07cf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#a181f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a691f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#aeacfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3bcff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "a",
    cx: 567.27,
    cy: 119.3,
    r: 114.12,
    fx: 567.27,
    fy: 119.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001dff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#031efe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3131f9",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5641f5",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#734df2",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8756f0",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#935bef",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#975def",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#955beb",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8250cf",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7b4cc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "b",
    cx: 6618.63,
    cy: 2477.22,
    r: 131.56,
    fx: 6618.63,
    fy: 2477.22,
    gradientTransform: "rotate(78.24 5045.988 -2341.142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#004080",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#004080",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52c7cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#E",
    id: "c",
    cx: 6645.32,
    cy: 2484.29,
    r: 94.5,
    fx: 6645.32,
    fy: 2484.29,
    gradientTransform: "rotate(123.24 4127.639 -521.822)scale(1 .8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "z",
    cx: 1281.14,
    cy: 32.02,
    r: 16.1,
    fx: 1281.14,
    fy: 32.02,
    gradientTransform: "matrix(.05878 -.99827 .70877 .04174 1183.11 1309.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e49392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e6938b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#eb9480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ed957d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed627d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Z",
    id: "AP",
    cx: 965.73,
    cy: 36.16,
    r: 32.02,
    fx: 965.73,
    fy: 36.16
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "AQ",
    cx: 1123.49,
    cy: -1749.73,
    r: 45.47,
    fx: 1123.49,
    fy: -1749.73,
    gradientTransform: "rotate(169.77 959.03 -868.098)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#E",
    id: "AR",
    cx: 1217.8,
    cy: -1704.01,
    r: 45.47,
    fx: 1217.8,
    fy: -1704.01,
    gradientTransform: "rotate(164.48 959.034 -868.09)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "AS",
    cx: 1205.34,
    cy: -1418.94,
    r: 124.86,
    fx: 1205.34,
    fy: -1418.94,
    gradientTransform: "rotate(-135 1750.112 -718.564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ddbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7cf7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#81f7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#91fadf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#acfec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3ffc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "AT",
    cx: 1702.85,
    cy: -1594.95,
    r: 119.05,
    fx: 1702.85,
    fy: -1594.95,
    gradientTransform: "rotate(-173.24 1750.136 -718.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff39",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02fe3d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1ef374",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#35eaa1",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#47e3c4",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#53dedc",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5adbea",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5ddbef",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#56ccdf",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#50bfd0",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4db7c7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4cb4c4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#Ai",
    id: "AU",
    cx: 6861.84,
    cy: 1401.89,
    r: 182.29,
    fx: 6861.84,
    fy: 1401.89,
    gradientTransform: "rotate(78.24 5045.988 -2341.142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5f31cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5f31cc",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5f31cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#E",
    id: "AV",
    cx: 6898.6,
    cy: 1411.61,
    r: 130.88,
    fx: 6898.6,
    fy: 1411.61,
    gradientTransform: "rotate(123.24 4565.293 -707.292)scale(1 .8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ag",
    d: "M657.46 160c-1.38-35.7-30.74-64.23-66.78-64.23s-65.4 28.52-66.78 64.23h133.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ah",
    d: "M657.31 160c-.14-3.69-.57-7.41-1.35-11.14-7.51-36.05-42.82-59.19-78.87-51.68-30.66 6.38-51.96 32.87-53.04 62.83h133.26Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M.11 0h1920v160H.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M199.71 0c-5.4 8.38-9.5 17.79-11.97 28.02-11.76 48.89 18.33 98.06 67.23 109.82 48.89 11.76 98.06-18.33 109.82-67.23C370.85 45.44 365.8 20.18 352.8 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M199.71 0a91.4 91.4 0 0 0-9.48 19.49c-16.48 47.51 8.68 99.39 56.19 115.87s99.39-8.68 115.87-56.19c9.53-27.5 5.12-56.46-9.5-79.17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M352.8 0H199.72c-16.25 25.28-19.66 58.05-6.17 87.38 21.02 45.68 75.09 65.68 120.77 44.66S380 56.95 358.98 11.27A91 91 0 0 0 352.8 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M199.58 0a91.2 91.2 0 0 0-9.5 19.54c-11.89 34.27-2.13 70.81 22.03 94.73l.72.7c9.24 8.96 20.54 16.09 33.51 20.59 19.48 6.75 39.68 6.52 57.89.61.38-.12.75-.23 1.13-.37 25.77-8.71 47.38-28.82 56.99-56.5 9.55-27.55 5.12-56.56-9.52-79.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.38 74.72-.31-1.1c-2.61-9.42-4.16-20.63-4.63-33.47-.49-13.2-2.05-27.34-5.64-40.15h-1.13c3.63 12.79 5.2 26.97 5.68 40.19.49 13.19 2.05 24.57 4.7 34.08l.31 1.11c3.6 12.42 9.1 21.55 16.42 27.3 3.99 3.12 7.93 4.74 11.29 5.55a25.3 25.3 0 0 0 5.04.71l.91-1.08c-3.73-.05-10.16-1-16.6-6.06-7.08-5.56-12.48-14.72-16.04-27.08M286.89 0l-6.71 3.83c-47.71 29.36-55.73 32.48-85.08 4.18l-.5 1.01c10.71 10.3 19.17 16.85 27.96 18.97a27.2 27.2 0 0 0 8.07.69c11.99-.79 25.43-8.75 50.11-23.93 2.92-1.79 5.75-3.36 8.51-4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.92 70.06c-2.17-2.18-6.45-5.52-13.26-6.71-10.59-1.85-23.68 2.06-38.27 11.38l-1.02.65c-2.79 1.82-5.62 3.83-8.51 6.04-10.18 7.77-18.62 9.4-26.18 7.58-9.35-2.25-17.35-9.77-25.61-17.53-16.01-15.05-34.11-32.06-66.76-17.74-.02-.39-.04-.77-.04-1.16 33.05-14.31 51.33 2.89 67.54 18.11 15.24 14.31 28.39 26.67 50.39 9.88a147 147 0 0 1 8.86-6.29l1.02-.65c14.82-9.46 27.83-13.27 38.8-11.33 6.65 1.18 10.95 4.23 13.34 6.51l-.29 1.26zm-152.81 44.21.66-.53c10.17-8.08 21.69-12.94 33.31-14.07a52.6 52.6 0 0 1 9.72-.03c9.24.84 17.97 4.16 24.84 9.59 5 3.94 9.07 8.97 13 13.84 2.81 3.48 5.71 7.08 8.94 10.24.86.84 1.78 1.68 2.78 2.48-.37.14-.75.25-1.13.37a45 45 0 0 1-2.35-2.13c-3.26-3.21-6.19-6.83-9.02-10.32-3.9-4.82-7.93-9.81-12.84-13.69-9.07-7.15-21.4-10.56-33.85-9.36-11.43 1.1-22.77 5.89-32.79 13.85-.18.15-.38.3-.56.45l-.72-.7z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m296.55 48.32-2.5 90.32s36.43-6.78 51.06-29.7z",
    className: "Bl",
    opacity: 0.38
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M990.93 0h-58.28c-11.73 8.84-19.32 22.52-19.32 38.35 0 26.76 21.7 48.46 48.46 48.46s48.46-21.7 48.46-48.46c0-15.83-7.59-29.51-19.32-38.35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#431593",
    d: "M879.35 39.61 756.17 9.82c-1.2-.29-2.36.62-2.36 1.86v145.28h11.96l114.07-64a1.93 1.93 0 0 0 .98-1.67V41.46c0-.88-.6-1.65-1.46-1.86z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a17a3",
    d: "M763.4 31.24v44.6a1.99 1.99 0 0 0 2.25 1.97l106.29-13.83c.99-.13 1.73-.97 1.73-1.97V49.52c0-1.02-.77-1.87-1.79-1.98L765.59 29.26a2 2 0 0 0-2.2 1.98z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m872.51 41.19-93.07-18.2a2.28 2.28 0 0 1-1.84-2.27c.03-1.44 1.37-2.5 2.77-2.18l92.53 20.75c.45.1.77.49.77.95 0 .61-.56 1.07-1.16.96z",
    className: "Bo",
    opacity: 0.41
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m870.91 40.31-88.17-17.93a1.113 1.113 0 1 1 .46-2.18l87.71 19.09z",
    className: "Bp"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4e1ea3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.88,
    cy: 16.44,
    rx: 2.21,
    ry: 2.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 765.51,
    cy: 17.88,
    rx: 2.09,
    ry: 2.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.32,
    cy: 19.42,
    rx: 1.97,
    ry: 2.42
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 759.43,
    cy: 16.64,
    fill: "url(#H)",
    rx: 2.21,
    ry: 2.72
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 766.07,
    cy: 18.08,
    fill: "url(#I)",
    rx: 2.09,
    ry: 2.57
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.88,
    cy: 19.61,
    fill: "url(#J)",
    rx: 1.97,
    ry: 2.42
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M763.58 84.93v31.41a1.35 1.35 0 0 0 1.8 1.27l107.4-32.19c.54-.19.9-.7.9-1.27V67.53c0-.83-.74-1.46-1.56-1.33l-107.4 17.4c-.65.11-1.13.67-1.13 1.33z",
    className: "Bo",
    opacity: 0.41
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M809.86 92.69c-.11 2.08 1.85 3.67 3.86 3.13l26.97-7.22a2.42 2.42 0 0 0 1.8-2.23 2.44 2.44 0 0 0-2.96-2.51l-27.27 5.99c-1.35.3-2.34 1.46-2.41 2.84z",
    className: "Bp"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M879.35 39.61 756.17 9.82c-1.2-.29-2.36.62-2.36 1.86v142.59h16.76l109.27-61.31a1.93 1.93 0 0 0 .98-1.67V41.46c0-.88-.6-1.65-1.46-1.86z",
    opacity: 0.78
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#431593",
    d: "M1159.69 156.38h11.54V11.67c0-1.24-1.16-2.15-2.36-1.86L1045.69 39.6c-.86.21-1.46.98-1.46 1.86v49.82a1.91 1.91 0 0 0 .98 1.67l113.28 63.56c.37-.08.78-.13 1.21-.13z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a17a3",
    d: "M1161.63 32.33v39.93c0 .74-.64 1.31-1.37 1.24l-107.79-11.32c-.63-.07-1.11-.6-1.11-1.24V46.75c0-.62.46-1.15 1.08-1.23l107.79-14.42c.74-.1 1.41.48 1.41 1.23Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.45 86.4v28.8a2.41 2.41 0 0 1-3.22 2.27l-105.27-31.54c-.96-.34-1.6-1.25-1.6-2.27V69.01a2.41 2.41 0 0 1 2.8-2.38l105.27 17.39c1.16.19 2.02 1.2 2.02 2.38",
    className: "Bo",
    opacity: 0.24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m1119.84 89.52.11 1.71a3.07 3.07 0 0 1-3.77 3.18l-36-8.43a3.09 3.09 0 0 1-2.37-2.8c-.12-2 1.67-3.58 3.63-3.21l35.89 6.72c1.38.26 2.42 1.43 2.5 2.83z",
    className: "Bp"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m1058.94 40.05 100.71-19.69a2.47 2.47 0 0 0 1.99-2.46 2.464 2.464 0 0 0-3-2.36l-100.12 22.45c-.48.11-.83.54-.83 1.03 0 .66.6 1.16 1.26 1.04z",
    className: "Bo",
    opacity: 0.41
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "m1060.68 39.1 95.4-19.4a1.21 1.21 0 0 0 .97-1.18c0-.77-.71-1.34-1.47-1.18L1060.67 38v1.11z",
    className: "Bp"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#4e1ea3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1047.19,
    cy: 41.96,
    rx: 1.06,
    ry: 1.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1050.95,
    cy: 41.28,
    rx: 1.01,
    ry: 1.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1054.59,
    cy: 40.37,
    rx: 0.95,
    ry: 1.17
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1047.36,
    cy: 41.66,
    fill: "url(#O)",
    rx: 1.06,
    ry: 1.31
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1051.13,
    cy: 40.98,
    fill: "url(#P)",
    rx: 1.01,
    ry: 1.24
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1054.77,
    cy: 40.07,
    fill: "url(#Q)",
    rx: 0.95,
    ry: 1.17
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M1160.36 156.48h10.87V11.67c0-1.24-1.16-2.15-2.36-1.86L1045.69 39.6c-.86.21-1.46.98-1.46 1.86v49.82a1.91 1.91 0 0 0 .98 1.67l113.61 63.75c.47-.14.98-.22 1.55-.22z",
    opacity: 0.78
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M662.61 160V32.91L366.67 0h-16.81v160z",
    className: "Bl"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M652.59 160V75.19c0-2.62-2.04-4.79-4.66-4.94l-86.43-5.03a4.94 4.94 0 0 0-5.23 4.94V160z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M641.78 60.31 372.66 41.18c-7.2-.51-12.77-6.5-12.77-13.71 0-8.13 7.01-14.48 15.09-13.68l268.5 26.4c5.17.51 9.11 4.86 9.11 10.05 0 5.86-4.97 10.49-10.81 10.07",
    className: "Bq"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m590.71 51.03-169.18-14.7a5.593 5.593 0 0 1-5.14-5.97 5.6 5.6 0 0 1 6.07-5.19l169.26 15.94c2.37.29 4.2 2.23 4.37 4.61a4.99 4.99 0 0 1-5.38 5.31",
    opacity: 0.19
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 401.31,
    cy: 28.96,
    r: 4.71,
    fill: "url(#T)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.18,
    cy: 27.74,
    r: 4.71,
    fill: "url(#U)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.69,
    cy: 26.57,
    r: 4.71,
    fill: "url(#V)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M662.61 160V32.91l-99.98-11.09.65 138.18z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M548.88 160V68.93c0-2.5-1.95-4.56-4.44-4.7L364.86 53.78a4.705 4.705 0 0 0-4.98 4.7v101.53h189z",
    className: "Bq",
    opacity: 0.63
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M425.17 100.75h25.79V160h-25.79z",
    opacity: 0.35
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M474.37 137.19h25.79V160h-25.79z",
    opacity: 0.35
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f29065",
    strokeWidth: 0.5,
    d: "M395.66 160V65.92",
    className: "Bm Bn"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bb98",
    d: "m405.8 147.76 21.39-26.27c1.62-1.91 4.46-2.31 6.34-.9l.27.22.03.02 16.83 14.54-4.32.57c9.07-9.51 18.36-18.51 27.54-27.29l28.87-25.45c4.95-.28 6.29 3.39 4.01 5.28l-.03.03-27.94 24.15c-9.34 8.66-18.56 17.72-28.01 26.91l-.1.1c-1.18 1.17-3.03 1.38-4.21.5l-19.08-11.91 6.63-.74-23.7 23.82-.11.11c-1.24 1.3-3.19 1.48-4.34.39-1.07-1.02-1.08-2.79-.07-4.08",
    opacity: 0.5
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ag",
    fill: "url(#Z)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ag",
    fill: "url(#a)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M657.23 160c-.14-3.71-.57-7.45-1.35-11.21-7.5-36.01-42.77-59.12-78.78-51.62-30.65 6.38-51.93 32.88-52.98 62.83h133.1Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffaab0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.86 96.54c-12.11 15.16-27.11 19.63-37.6 20.7a60 60 0 0 1-6.13.31c-8.26 0-13.99-1.65-14.06-1.68l.07-.25.07-.23a1 1 0 0 0 .13.04c1.1.3 9.3 2.39 19.89 1.31 10.33-1.06 25.09-5.44 37.05-20.27l.59.09zm35.53 57.41c-9.29 0-22.6-1.73-45.76-6.76-43.95-9.54-64.22-1.78-64.42-1.7l-.19-.47c.2-.08 20.58-7.91 64.71 1.67 43.81 9.51 52.25 7.21 65.02 3.71l.6-.16.13.49-.6.16c-6.07 1.66-11.17 3.05-19.5 3.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.47 160c6.62-5.97 12.43-12 17.32-17.49 16.74-18.81 26.5-35.61 26.6-35.77l-.44-.25c-.1.17-9.84 16.93-26.55 35.7-4.98 5.59-10.93 11.74-17.7 17.82h.76z"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ah",
    fill: "url(#c)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ah",
    fill: "url(#d)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#5018b0",
    d: "m798.03 160 3.35-1.55V37.53c0-1.69-1.23-3.12-2.89-3.39L612.53 4.54a3.434 3.434 0 0 0-3.97 3.39V160z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M693.14 160V42.01a3.99 3.99 0 0 0-3.67-3.98l-68.02-5.53a3.995 3.995 0 0 0-4.32 3.98V160z",
    className: "Bl",
    opacity: 0.48
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "Br"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.31,
    cy: 16.49,
    rx: 3.19,
    ry: 3.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.29,
    cy: 17.62,
    rx: 3.03,
    ry: 3.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 639.4,
    cy: 18.9,
    rx: 2.97,
    ry: 3.65
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.11,
    cy: 16.61,
    fill: "url(#e)",
    rx: 3.19,
    ry: 3.93
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 630.09,
    cy: 17.78,
    fill: "url(#f)",
    rx: 3.03,
    ry: 3.73
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 640.24,
    cy: 19.02,
    fill: "url(#g)",
    rx: 2.97,
    ry: 3.65
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M793.24 40.09 650.52 23.77a3.543 3.543 0 0 1-3.17-3.52 3.54 3.54 0 0 1 3.99-3.51l142.32 19.75a1.82 1.82 0 0 1 1.58 1.8c0 1.07-.93 1.91-2 1.8",
    className: "Br"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "Bm Bn",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00c8d7",
    d: "m701.31 52.7 93.93-.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#h)",
    strokeWidth: 0.95,
    d: "m701.31 65.12 93.93-4.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#i)",
    strokeWidth: 0.9,
    d: "m701.31 77.54 93.93-8.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#j)",
    strokeWidth: 0.85,
    d: "m701.31 89.96 93.93-12.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#k)",
    strokeWidth: 0.8,
    d: "m701.31 102.39 93.93-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#l)",
    strokeWidth: 0.75,
    d: "m701.31 114.81 93.93-20.93"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m705.9 159.5 87.94-31.1c.84-.3 1.4-1.1 1.4-1.99v-26.24c0-1.37-1.29-2.39-2.62-2.06l-88.69 21.9c-1.53.38-2.6 1.75-2.6 3.33v32.95a3.43 3.43 0 0 0 4.59 3.22z",
    className: "Br"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#m)",
    strokeWidth: 4,
    d: "m702.04 43.81 37.18 1.26",
    className: "Bm Bn",
    opacity: 0.38
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.69 0h201.5v160h-201.5z",
    className: "Bl"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#5018ad",
    d: "M1455.22 160V22.92c0-3.84-3.24-6.88-7.07-6.66l-48.71 2.84c-3.53.21-6.29 3.13-6.29 6.66V160h62.06z",
    opacity: 0.66
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m1398.24 0-5.09.5v12.88L1581.41 0z",
    className: "Bq"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1437.63 0c-.48.52-.79 1.2-.84 1.95-.13 1.96 1.51 3.58 3.46 3.42L1507.67 0z",
    opacity: 0.19
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1408.49,
    cy: 5.04,
    r: 3.03,
    fill: "url(#n)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1418.23,
    cy: 4.25,
    r: 3.03,
    fill: "url(#o)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1428.21,
    cy: 3.5,
    r: 3.03,
    fill: "url(#p)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m1435.31 160 28.54-160h-77.16v160z",
    opacity: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M1459.97 20.11v81.53c0 2.46 1.85 4.52 4.29 4.78l112.14 12.26c2.85.31 5.34-1.92 5.34-4.78V13.59c0-2.77-2.33-4.97-5.09-4.8l-112.14 6.53a4.82 4.82 0 0 0-4.53 4.8z",
    className: "Bk"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "Bk"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00c8d7",
    d: "M1581.73 129.82h-.06l-121.76-15.17a.49.49 0 0 1-.43-.56c.03-.27.28-.46.56-.43l121.76 15.17a.49.49 0 0 1 .43.56c-.03.25-.25.44-.5.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00bed7",
    d: "M1581.87 140.21h-.07l-121.91-17.29a.5.5 0 1 1 .15-.99l121.91 17.29a.5.5 0 0 1 .42.57c-.04.25-.25.43-.49.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b4d7",
    d: "M1582.02 150.6h-.08l-122.05-19.41a.505.505 0 0 1-.42-.57.5.5 0 0 1 .57-.42l122.05 19.41c.27.04.46.3.42.57-.04.25-.25.42-.49.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00aad7",
    d: "M1459.88 139.45 1575.22 160h5.76l-120.93-21.53a.5.5 0 1 0-.17.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a0d7",
    d: "m1459.87 147.72 62.36 12.28h5.26l-67.44-13.26a.506.506 0 0 0-.59.4c-.05.27.12.53.4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0096d7",
    d: "m1459.87 155.99 18.02 4.01h4.85l-22.67-4.99a.495.495 0 0 0-.59.39c-.06.27.12.54.39.59"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m1515.3 65.36-30.13-7.26c2.62-18.8 15.15-31.72 30.16-31.14l-.03 38.39Z",
    className: "Bk"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m1515.3 65.36 10.43 36.01c-15.88 7.38-33.42-2.85-39.18-23.1-1.92-6.77-2.35-13.11-1.37-20.17l30.13 7.26Z",
    className: "Bj"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m1515.3 65.36.03-38.39c16.91.66 30.59 18.06 30.56 38.87-.02 16.17-7.83 29.9-20.17 35.54l-10.43-36.01z",
    className: "Bl",
    opacity: 0.44
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c1cc9",
    d: "m1160.16 0-13.86 3.42a9.08 9.08 0 0 0-6.9 8.81V160h251.22V0h-230.47z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#40158f",
    d: "m1147.24 118.32 84.37 26.45c1.42.45 2.87-.6 2.9-2.09l.97-60.99c.02-1.17-.87-2.15-2.03-2.26l-85.33-7.64a2.23 2.23 0 0 0-2.43 2.22v42.18c0 .97.63 1.84 1.56 2.13z",
    opacity: 0.67
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m1203.47 0-55.02 11.07a4.47 4.47 0 0 0-3.59 4.41c.02 2.73 2.47 4.8 5.16 4.38L1286.74 0h-83.26z",
    className: "Bl"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d17a8",
    d: "m1213.87 0-37.58 7.56a2.95 2.95 0 0 0-2.36 2.91c.01 1.8 1.62 3.16 3.4 2.88L1274.3 0h-60.44z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1150.25,
    cy: 15.22,
    r: 2.77,
    fill: "url(#u)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1159.09,
    cy: 13.83,
    r: 2.77,
    fill: "url(#v)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1168.14,
    cy: 12.45,
    r: 2.77,
    fill: "url(#w)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d17a8",
    d: "m1336.84 0-188.55 25.38a3.95 3.95 0 0 0-3.42 3.92v33.97a3.95 3.95 0 0 0 3.69 3.94l230.09 15.05a3.95 3.95 0 0 0 4.21-3.94V0h-46.01z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M1291.19 64.67c-6.4 4.57-13.72 1.83-19.21-2.74-11.89-10.06-24.7-34.77-40.25-22.87-15.79 13.36-34.81 26.31-54.65 30.03l199.83 13.07c-27.48-10.81-53.74-38.23-85.72-17.49",
    opacity: 0.42
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M1378.1 61.92c-12.81-18.3-29.28-43-53.98-35.68-18.3 4.57-30.19 21.04-46.66 31.11-9.15 5.49-21.04 6.4-30.19 0-8.23-7.32-17.38-14.64-27.45-13.72-26.27 3.5-47.51 27.95-74.15 22.02.67.89 1.69 1.49 2.88 1.57l230.09 15.05a3.95 3.95 0 0 0 4.21-3.94V66.44c-1.67-1.18-3.27-2.67-4.75-4.52",
    opacity: 0.2
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1281.39,
    cy: 26.07,
    fill: "url(#z)",
    opacity: 0.51,
    rx: 7.8,
    ry: 10.85
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#AA)",
    strokeWidth: 6,
    d: "m1244.13 86.14 72.33 7.79",
    className: "Bm Bn",
    opacity: 0.5
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "Bj"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00c8d7",
    d: "M1379.34 114.72h-.07l-137.01-20.01a.5.5 0 0 1-.42-.57c.04-.27.29-.47.57-.42l137.01 20.01a.5.5 0 0 1 .42.57c-.04.25-.25.43-.49.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AB)",
    d: "M1379.34 124.48h-.08l-137.22-22.94a.5.5 0 0 1 .17-.99l137.22 22.94a.5.5 0 0 1 .41.58c-.04.24-.25.42-.49.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AC)",
    d: "M1379.34 134.25h-.09l-137.44-25.88a.5.5 0 0 1-.4-.58.5.5 0 0 1 .58-.4l137.44 25.88a.5.5 0 0 1 .4.58c-.04.24-.25.41-.49.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AD)",
    d: "M1379.34 144.02s-.07 0-.1-.01l-137.66-28.81c-.27-.06-.44-.32-.39-.59s.32-.44.59-.39l137.66 28.81c.27.06.44.32.39.59a.5.5 0 0 1-.49.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AE)",
    d: "M1379.34 153.78s-.07 0-.11-.01l-137.88-31.75a.503.503 0 0 1 .22-.98l137.88 31.75c.27.06.44.33.38.6-.05.23-.26.39-.49.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AF)",
    d: "M1241.12 128.85 1363.74 160h4.1l-126.48-32.12a.5.5 0 0 0-.61.36c-.07.27.1.54.36.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AG)",
    d: "m1240.89 135.67 88.13 24.33h3.81l-91.67-25.29c-.27-.07-.54.08-.61.35s.08.54.35.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AH)",
    d: "m1240.66 142.5 58.55 17.5h3.56l-61.83-18.46a.5.5 0 0 0-.62.34c-.08.27.07.54.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AI)",
    d: "m1240.43 149.33 32.9 10.67h3.34l-35.95-11.62a.5.5 0 0 0-.63.33c-.08.26.06.54.33.63z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AJ)",
    d: "M1148.16 0h-35.12c-24.26 15-14.79 30.75-42.35 20.07-13.43-5.21-3.57 9.74-34.23 17.41L1143.5 11.9c3.61-.86 6.02-4.31 5.53-8-.17-1.26-.44-2.6-.88-3.9z",
    className: "Bk"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AK)",
    d: "M653.46 160h53.28c68.19-25.43 206.75-85.07 206.75-85.07s-18.78-9.62-39.84 3.34c-21.05 12.95-25.98-10.12-37.5-14.05s-28.12 18.03-36.68 13.81-20.87-26.06-45.79-8.44-70.75 68.69-107.51 90.42c.3-.1 7.28 0 7.28 0z",
    className: "Bj"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AL)",
    d: "m880.34 35.07-75.86-18.2c-2.51-.6-4.18-3-3.84-5.56.72-5.47 4.36-12.95 20.14-5.36 23.05 11.09 13.5 24.68 34.3 16.64 9.55-3.69 2.15 7.25 25.26 12.48",
    className: "Bk"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AM)",
    d: "m345.71 160 6.42-13.58 11.5 13.58h58.88l-36.08-42.62 44.56-11.09-134.44-57.58L323.64 160z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d1cca",
    d: "M354.44 73.51c-15.99-1.06-27.95 5.19-35.55 18.6-4.99 8.79-6.43 17.94-6.76 20.58l-2.32-9.5c1.1-3.91 2.8-8.55 5.42-13.15 4.94-8.7 13.96-18.52 29.95-20.49l9.25 3.97zm-37.2-15.93c-6.28 2.39-11.41 6.82-15.31 13.25l-1.34-5.51c2.8-3.72 6.53-7.33 11.47-9.96zm76.95 33.34c-26.24-1.13-46.55 9.2-60.37 30.69-7.52 11.71-10.98 23.73-12.33 29.56l-2.06-8.46c2.04-6.44 5.4-14.86 10.77-23.26 9.19-14.35 26.03-30.96 55.22-32.68l8.78 3.76-.02.38z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AN)",
    d: "M1008.86 95.45s3.53 4.35 17.31 5.42z",
    className: "Bk"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AO)",
    d: "M1260.07 160c-29.47-31.5-47.65-88.82-83.05-57.08-11.46 10.27-42.69 34.74-32.93-1.83 3.91-14.65 18.46-62.26-19.98-43.56-38.21 18.59-31.06 35.45-69.84 41.43-12.31 1.9-21.41 2.14-28.1 1.62L1220.18 160z",
    className: "Bk"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.39,
    cy: 35.82,
    r: 32.02,
    fill: "url(#AP)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.39,
    cy: 35.82,
    r: 32.02,
    fill: "url(#AQ)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.39,
    cy: 35.82,
    r: 32.02,
    fill: "url(#AR)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AS)",
    d: "M1761.44 160c-2.86-18.78-11.51-36.85-25.97-51.32-36.05-36.05-94.51-36.05-130.57 0-14.46 14.46-22.99 32.54-25.85 51.32z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AT)",
    d: "M1761.44 160c-6.1-40.03-38.24-72.72-80.4-77.72-49.6-5.88-94.51 28.71-101.98 77.72h182.39Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AU)",
    d: "m1761.44 160-.85-4.68c-10.39-49.89-59.3-82.16-109.19-71.77-38.72 8.06-67.03 39.43-72.34 76.45z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#d438ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1652.22 100.43c3.18 8.56 3 19.34-.46 31.91a14 14 0 0 1-.32 1.12c-2.34 8.15-6.05 17.04-11.06 26.53h1.24c5.03-9.58 8.73-18.44 11.05-26.56l.32-1.12c3.46-12.65 3.55-23.46.25-32.3-1.8-4.81-4.35-8.3-6.83-10.78-1.4-1.4-2.77-2.48-3.98-3.28l-1.36.45c3.21 2.02 8.26 6.25 11.15 14.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.89 122.72c8.46 7.48 21.73 11.08 39.55 10.74.41 0 .82-.02 1.23-.02 3.5-.1 7.16-.35 10.99-.75 24.23-2.5 31.07 10.47 36.12 27.31h1.13c-2.46-8.24-5.42-15.8-10.72-21.1-5.58-5.58-13.74-8.63-26.65-7.3-3.67.38-7.18.62-10.56.72-.41 0-.82.02-1.23.02-17.55.34-30.94-3.21-39.12-10.42-5.26-4.64-7.26-10.01-7.98-13.05-.32.3-.6.61-.9.92.86 3.24 3.01 8.38 8.13 12.92z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#11197a",
    d: "m1683.85 110.84-71.86-8.35s17.51-15.48 41.88-19.38l29.99 27.73Z",
    opacity: 0.79
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AV)",
    d: "M1761.7 160c-.51-1.6-.8-3.2-1.13-4.8-10.4-49.95-59.33-82.01-109.28-71.61-38.8 8.08-66.81 39.41-72.24 76.41z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e0e64",
    d: "M836.93 106.76h248.92v21.26H836.93z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#331071",
    d: "m1085.85 106.76-90.86-28.28a5.4 5.4 0 0 0-1.61-.24h-63.96a5.4 5.4 0 0 0-1.61.24l-90.86 28.28h248.92z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#48169e",
    d: "m1064.87 102.36-69.22-22.98a3.7 3.7 0 0 0-1.21-.19h-66.1a4 4 0 0 0-1.21.19l-69.22 22.98c-1.08.36-.74 1.56.45 1.56h206.06c1.18 0 1.53-1.2.45-1.56"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AW)",
    d: "m1013.45 86.38-18.62-6.55s-.07-.02-.11-.02h-66.35l-.11.03-17.84 6.54c-.26.09-.17.37.11.37h102.81c.28 0 .37-.29.11-.37",
    className: "Bj"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AX)",
    d: "m905.62 88-29.09 9.79c-3.02 1.02-2.04 4.37 1.27 4.37h78.34c.73 0 1.34-.41 1.4-.95l1.45-12.28c.07-.61-.57-1.13-1.4-1.13H906.9c-.44 0-.87.07-1.27.2z",
    className: "Bj"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AY)",
    d: "m1017.76 87.87 37.07 12.77c1.04.36.7 1.52-.45 1.52h-88.03c-.56 0-1.02-.32-1.07-.73l-1.5-12.77c-.05-.47.44-.87 1.07-.87h52.47a1.6 1.6 0 0 1 .45.07z",
    className: "Bj"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e0e64",
    d: "M689.56 152.61h543.66V160H689.56z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#431492",
    d: "m1104.72 113.6 128.5 39.01H689.56l125.3-39.01z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#5319b5",
    d: "m1101.99 114.66 101.58 33.72H718.89l101.71-33.36z"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 822.67,
    cy: 116.7,
    fill: "url(#AZ)",
    rx: 2.25,
    ry: 0.48
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 829.76,
    cy: 116.7,
    fill: "url(#Aa)",
    rx: 2,
    ry: 0.43
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.51,
    cy: 116.7,
    fill: "url(#Ab)",
    rx: 2,
    ry: 0.43
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1103.96 117.13H840.97l.54-.41c.37-.28.87-.44 1.4-.44h258.26a2.5 2.5 0 0 1 .88.15l1.9.7z",
    opacity: 0.21
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ac)",
    d: "M1149.27 133.09H773.51l43.51-14.99h288.74z",
    className: "Bj"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#431492",
    d: "M1010.37 121.21h-3.55c-4.21.1-8.33.55-12.32 1.51-33.85 7.25-66.94 8.61-100.02 1.81-4.62-1.36-10-.45-14.62.45-20.8 2.38-40.31 6.3-60.46 8.1h295.83c-22.22-.4-44.93-3.12-66.09-6.29-12.89-2.22-26.16-5.31-38.76-5.59z",
    opacity: 0.44
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ad)",
    d: "M883.27 135h-115.3l-31.57 10.88 133.04-.26z",
    opacity: 0.34
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ae)",
    d: "m784.86 135-14.48 1.76c-4.1.52-7.9.84-12.6 1.75l-10.28 3.54c3.17-.83 6.56-1.23 9.43-1.81 5.06-1.02 9.39-1.6 13.76-2.15L797.2 135zm89.31 4.12-5 .58c-3.41.38-7.57.78-10.98.84 2.53-.81 4.81-1.73 5.56-2.5.51-.54.33-.95.16-1.15-.52-.68-1.97-.7-4.62-.49-.73.05-1.63.13-2.81.4-1.98.46-4.32 1.42-5.22 2.14-.51.41-.72.83-.64 1.23.06.31.3.57.68.8-10.75 2.37-17.59 2.36-19.62 1.27-.51-.27-.57-.53-.58-.69 0-.17.05-.38.09-.61.06-.35.17-.86 0-1.33 1.56-.44 3.11-.96 4.36-1.55 1.36-.64 2.05-1.24 2.17-1.86.07-.38-.09-.75-.45-1.05-.05-.05-.12-.09-.18-.14h-18.73l-7.14 1.07-11.62 1.97-18.49 3.01a46 46 0 0 0 1.35-.36c.43-.12 4.27-1.23 5.04-2.13.27-.32.28-.68.02-.95-.42-.45-1.21-.6-4.21-.15-3.68.57-8.84 1.83-11.61 3.13-.45.21-1.35.64-1.64 1.19-11.47 1.92-23.5 3.08-31.04 3.19l-2.61.92 15.1-.26c5.75-.54 12.27-1.42 19.27-2.6.69.23 2.07.35 4.99.04 7.21-.77 15.88-2.28 24.26-3.73l11.6-1.97c18.92-3.06 23.36-2.16 24.33-1.36 0 0-.07.31-1.35.91-1.31.62-3.03 1.16-4.73 1.61-.07-.02-.14-.04-.23-.06-1.17-.26-3.04-.17-5.87.06-5.43.46-11.42 1.15-17.77 2.05l-.18.03c-.61.19-2.22.68-2 1.58.06.24.37.81 1.82.83 4.77.05 11.3-.61 18.87-1.93a76 76 0 0 0 4.99-1.04c.02.13-.02.34-.08.68-.05.26-.11.54-.11.83.04.7.49 1.31 1.33 1.76 3.01 1.6 11.34 1.14 21.75-1.2.52-.11 1.1-.26 1.71-.41 3 .37 7.87.14 15.36-.69l5.01-.58 2.04-.24 2.1-1.6-4.42.52zm-99.77 1.89c2.7-.96 6.5-1.83 9.27-2.26.14-.02.25-.03.37-.05-.63.23-1.39.48-2.22.72-2.02.57-3.93.95-5.72 1.28l-1.7.32zm33.7.64a334 334 0 0 1 15.12-1.72c-5.83.99-10.99 1.58-15.12 1.72m45.83-1.32c-.55-.09-1.03-.21-1.4-.36-.02-.01-.04-.02-.05-.03.03-.03.06-.06.11-.1.54-.44 2.49-1.32 4.43-1.77 1.01-.23 1.78-.3 2.47-.34a28 28 0 0 1 2.29-.11c-1.3.74-4.43 1.83-7.83 2.7z",
    className: "Bj"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.5,
    className: "Bm Bn"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#e86a61",
    d: "M888.71 135h266.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d46069",
    d: "M887.55 136.1h270.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c15572",
    d: "M886.39 137.2h274.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ad4b7a",
    d: "M885.23 138.3h279.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9a4083",
    d: "M884.08 139.4h283.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#86368b",
    d: "M882.92 140.5h287.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#722b93",
    d: "M881.76 141.6h292.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f219c",
    d: "M880.6 142.7h296.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4b16a4",
    d: "M879.45 143.8h300.65"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Af)",
    d: "m1625.41 0-6.16 16.44L1602.81 0h-64.68l48.78 48.78-44.26 15 141.2 47.06L1646.9 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroApp);
export default __webpack_public_path__ + "static/media/hero-app.1308b02da346c9ad3e7c7588e2432fad.svg";
export { ForwardRef as ReactComponent };